/** Replaces the compare and dust sections while every epoch plays at once. */
export function StackedNote() {
  return (
    <div className="panel-section">
      <p className="muted" style={{ fontSize: 11 }}>
        All-epochs mode plays every observed spectrum in parallel. Use the per-epoch
        faders below the plot to balance the mix or solo a single observation. A/B
        comparison and the dust model are disabled in this view.
      </p>
    </div>
  );
}
